<template>
  <div
    class="modal fade"
    id="uploadProgressModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content msm-form-container">
        <div class="modal-header">
          <h4 class="modal-title">
            <b>{{ lang.UPM000 }}...</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="progress">
            <div
              class="progress-bar progress-bar-msm"
              :style="`width: ${globals.currentUploadProgress}%`"
            ></div>
          </div>
          {{ globals.currentUploadProgress }} %
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-danger"
            @click="globals.cancelPendingUploads();closeModal();"
          >
            {{ lang.UPM001 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadProgressModal",
  data() {
    return {
      lang: {
        UPM000: "Uploading",
        UPM001: "Cancel",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUploadProgress"(newValue) {
      if (newValue === 100) this.closeModal();
      else {
        setTimeout(() => {
          if (this.globals.currentUploadProgress < 50) this.openModal();
        }, 1000);
      }
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  methods: {
    openModal() {
      $("#uploadProgressModal").modal("show");
    },
    closeModal() {
      $("#uploadProgressModal").modal("hide");
    },
  },
};
</script>

<style scoped>
.modal {
  overflow-y: hidden !important;
}
.modal-dialog {
  width: 400px;
  margin: 40vh auto;
}

.progress {
  width: 100%;
  height: 0.3em;
  margin: 0.5em 0;
}

.progress-bar-msm {
  margin: 0;
  background: var(--color-primary-input);
}

@media (max-width: 1000px) {
  .modal-dialog {
    width: 70vw;
    margin: 20vh auto;
  }
  .modal-body {
    font-size: 2em;
  }

  .progress {
    font-size: 1em;
  }

  /* Overwrite some rules for portrait mode */
  @media screen and (max-aspect-ratio: 13/9) {
    .modal-dialog {
      width: 90vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// UploadProgressModal.vue?35de3984